module.exports = __webpack_public_path__ + "img/jr_banner_es.df2fc03c.jpg";